module.exports = __webpack_public_path__ + "img/Cert 08.8b96c677.png";